import { render, staticRenderFns } from "./c-player__bg.vue?vue&type=template&id=38830532&scoped=true"
import script from "./c-player__bg.vue?vue&type=script&lang=js"
export * from "./c-player__bg.vue?vue&type=script&lang=js"
import style0 from "./c-player__bg.vue?vue&type=style&index=0&id=38830532&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38830532",
  null
  
)

export default component.exports